import React from "react";

function AdvancePromotionPage() {
  return <div>AdvancePromotionPage</div>;
}

export default AdvancePromotionPage;
